import * as MutationsType from "./mutationsType";
import { teamsCollection } from "@/config/firebase";
import requestAxios from "@/helpers/request_axios";

export default {
  async getTeamById({ commit }, { id }) {
    const doc = await teamsCollection.doc(id).get();
    let team = null;

    if (!doc.empty) team = { id: doc.id, ...doc.data() };

    commit(MutationsType.SET_TEAM, team);
    return team;
  },
  async getTeamSchema({ commit, rootState }, { id }) {
    try {
      const teamId = rootState.Agent.agent.team_id;

      const response = await requestAxios({
        url: `/awy/api/v1/team/${teamId}/schemas/${id}`,
        method: "GET",
      });

      commit(MutationsType[`SET_SCHEMA_${id.toUpperCase()}`], response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getTicketFormFieldById({ commit, rootState, state }, { id }) {
    try {
      const teamId = rootState.Agent.agent.team_id;

      let field = (state.schemaTicketForm || []).find((s) => s.id === id);
      if (!field) {
        let response = await requestAxios({
          url: `/awy/api/v1/team/${teamId}/schemas/ticket_form/${id}`,
          method: "GET",
        });
        field = response.data.data;
      }
      commit(MutationsType.SET_FIELD_SCHEMA_TICKET_FORM, field);
    } catch (error) {
      console.error("getTicketFormFieldById: ", error);
      throw error.response.data;
    }
  },
  async saveTicketFormField({ commit, rootState }, payload) {
    try {
      const teamId = rootState.Agent.agent.team_id;

      let response = await requestAxios({
        url: `/awy/api/v1/team/${teamId}/schemas/ticket_form`,
        method: "POST",
        data: payload,
      });
      commit(MutationsType.ADD_TICKET_FORM_FIELD, response.data.data);
    } catch (error) {
      console.error("saveTicketFormField: ", error);
      throw error.response.data;
    }
  },
  async saveTicketImportField({ commit, rootState }, payload) {
    try {
      const teamId = rootState.Agent.agent.team_id;

      let response = await requestAxios({
        url: `/awy/api/v1/team/${teamId}/schemas/ticket_import`,
        method: "POST",
        data: payload,
      });
      commit(MutationsType.ADD_TICKET_IMPORT_FIELD, response.data.data);
    } catch (error) {
      console.error("saveTicketImportField: ", error);
      throw error.response.data;
    }
  },
  async updateTicketFormField({ commit, rootState }, { id, data }) {
    try {
      const teamId = rootState.Agent.agent.team_id;

      let response = await requestAxios({
        url: `/awy/api/v1/team/${teamId}/schemas/ticket_form/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_TICKET_FORM_FIELD, response.data.data);
    } catch (error) {
      console.error("updateTicketFormField: ", error);
      throw error.response.data;
    }
  },
  async updateSortTicketFormField({ rootState }, { id, data }) {
    try {
      const teamId = rootState.Agent.agent.team_id;

      await requestAxios({
        url: `/awy/api/v1/team/${teamId}/schemas/ticket_form/${id}/sort`,
        method: "PATCH",
        data: data,
      });
    } catch (error) {
      console.error("updateSortTicketFormField: ", error);
      throw error.response.data;
    }
  },
  async deleteTicketFormField({ commit, rootState }, { id }) {
    try {
      const teamId = rootState.Agent.agent.team_id;

      await requestAxios({
        url: `/awy/api/v1/team/${teamId}/schemas/ticket_form/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DETELE_TICKET_FORM_FIELD, { id });
    } catch (error) {
      console.error("deleteTicketFormField: ", error);
      throw error.response.data;
    }
  },
  resetTicketFormField({ commit }) {
    commit(MutationsType.SET_FIELD_SCHEMA_TICKET_FORM, null);
  },
  async getAllTeams({ commit }) {
    commit(MutationsType.SET_TEAMS, []);

    let snap = await teamsCollection.get();
    if (!snap.empty) {
      let teams = [];

      snap.forEach((doc) => {
        teams.push({ id: doc.id, ...doc.data() });
      });

      commit(MutationsType.SET_TEAMS, teams);
    }
  },
  async createTeam({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/team",
        method: "POST",
        data: payload.team,
      });
      commit(MutationsType.ADD_TEAM, response.data.data);
      return response.data;
    } catch (error) {
      console.error("createTeam: ", error);
      return error.response.data;
    }
  },
  async updateTeam({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/team/${payload.team_id}`,
        method: "PUT",
        data: payload.data,
      });
      commit(MutationsType.UPDATE_TEAM, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async removeTeam({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/team/${payload.team_id}`,
        method: "DELETE",
        data: payload.data,
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleTeam({ commit }) {
    commit(MutationsType.SET_TEAM, null);
    commit(MutationsType.SET_TEAMS, null);
    commit(MutationsType.SET_SCHEMA_TICKET_FORM, null);
    commit(MutationsType.SET_SCHEMA_CONTACT_FORM, null);
    commit(MutationsType.SET_SCHEMA_TICKET_EXPORT, null);
    commit(MutationsType.SET_SCHEMA_CONTACT_EXPORT, null);
  },
};
